import { motion } from 'framer-motion';
import teamGroupImg   from '../assets/IMG_0496.jpg'; // Team group at event
import twoLadiesImg   from '../assets/IMG_0490.jpg'; // Two ladies in pink
import editorialImg   from '../assets/IMG_0491.jpg'; // Bride Beauty editorial
import styles from './ProofOfWork.module.css';

const CARDS = [
  {
    img: teamGroupImg,
    alt: 'Shobha Salon team at industry event — Bharatpur\'s leading beauty professionals',
    label: 'Our Team',
    title: 'The People Behind the Magic',
    desc: 'Industry events, certifications & collaborations.',
  },
  {
    img: twoLadiesImg,
    alt: 'Shobha Ma\'am with client — happy clients at Shobha Beauty Parlour Bharatpur',
    label: 'Happy Clients',
    title: 'Glowing Together',
    desc: 'Every client leaves feeling truly beautiful.',
  },
  {
    img: editorialImg,
    alt: 'Bride Beauty editorial by Shobha Salon — Bharatpur bridal makeup',
    label: 'Editorial Work',
    title: 'Bride Beauty Feature',
    desc: 'Published work and bridal editorials.',
  },
];

export default function ProofOfWork() {
  return (
    <section id="proof" className={styles.section}>
      <div className={styles.inner}>

        {/* Heading */}
        <motion.div
          className={styles.heading}
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.75 }}
        >
          <span className={styles.headingTag}>Behind the Scenes</span>
          <h2 className={styles.headingTitle}>
            Beyond the Makeup Chair
          </h2>
          <span className={styles.headingScript}>Our Story</span>
          <p className={styles.headingSub}>
            Events, team milestones, editorial features and the people who make every
            bridal moment unforgettable in Bharatpur and beyond.
          </p>
        </motion.div>

        {/* Cards */}
        <div className={styles.grid}>
          {CARDS.map((card, i) => (
            <motion.div
              key={card.title}
              className={styles.card}
              initial={{ opacity: 0, y: 36 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.15 }}
              transition={{ duration: 0.75, delay: i * 0.12 }}
            >
              <img src={card.img} alt={card.alt} loading="lazy" />
              <div className={styles.cardOverlay}>
                <span className={styles.cardLabel}>{card.label}</span>
                <h3 className={styles.cardTitle}>{card.title}</h3>
                <p className={styles.cardDesc}>{card.desc}</p>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Bottom note */}
        <motion.div
          className={styles.note}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.5 }}
          transition={{ duration: 0.7, delay: 0.3 }}
        >
          <p className={styles.noteText}>
            Nationally certified. Trusted by countless clients across
            Rajasthan. Shobha Ma'am's work speaks for itself.
          </p>
        </motion.div>

      </div>
    </section>
  );
}
